export const CAFY_MESSAGES = {
	initial: {
		title: "Ship Free! Let's explore what matters most to you.",
		message: 'What would you like to focus on today?',
	},
	subDomainStep: {
		message: 'Which of these areas would you like to pay more attention to right now?',
		messageAfterSelection: "Let's take a closer look at [selected_areas_name].",
	},
	// The step that lists a sub-domain's terms names the area the way the person
	// just heard it, not by its internal category label.
	termStep: (area) => `What have you noticed about ${area}?`,
};
